/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'social-logo-quora': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M18.125 14.912h-1.25a1.075 1.075 0 01-1.081 1.075c-.719 0-1.138-.537-1.613-1.25a6.875 6.875 0 002.994-5.687c.056-4.494-3.656-7.431-7.606-7.431-3.95 0-7.694 2.987-7.694 7.362s3.75 7.369 7.606 7.369a6.694 6.694 0 001.919-.3c.719 1.319 1.619 2.337 3.412 2.337a3.125 3.125 0 003.313-3.475zm-5.088-2.156a3.944 3.944 0 00-3.475-1.975 3.75 3.75 0 00-2.337.719l.4 1a1.6 1.6 0 01.537-.063c1.138 0 1.875.957 2.575 2.276-.39.09-.792.13-1.193.118-2.757.019-3.919-1.956-3.919-5.787 0-3.832 1.194-5.813 3.894-5.813s3.95 1.975 3.95 5.813a12.953 12.953 0 01-.45 3.712h.018z"/>'
  }
})
